import { PathEditorNS } from "../../../../../../PathEditor/PathEditorNS.js";
export const _getPathEditorPointSizeControllerThrowable = (self) => {
  if (self._path_editor_point_size_controller == null) {
    throw new Error(
      `path_editor_point_size_controller 가 없습니다. 패스 편집을 먼저 시작해주세요.`
    );
  }
  return self._path_editor_point_size_controller;
};
